<template>
  <div ref="trend" class="trend">
    <div class="tab" :class="{ typeBlue: styleType == 'typeBlue' }">
      <div class="progress-control">
        <a
          class="home_tab home_tab_actived"
          :key="'0'"
          @click.stop="handleItem(0)"
          >{{ selectArr[0].name }}</a
        >

        <el-input
          :input-style="{ textAlign: 'center' }"
          class="home_tab_input"
          v-model="percentage"
          placeholder=""
          size="small"
        />

        <a
          class="home_tab home_tab_actived"
          :key="'1'"
          @click.stop="handleItem(1)"
          >{{ selectArr[1].name }}</a
        >
      </div>

      <div class="demo-progress">
        <el-progress
          type="dashboard"
          stroke-width="12"
          :percentage="percentage"
          :color="colors"
          width="180"
        >
          <template #default="{ percentage }">
            <p class="percentage-value">{{ percentage }}<span>μg/m³</span></p>
            <p class="percentage-label">工艺、负荷、物料污染预测</p>
          </template>
        </el-progress>
      </div>

      <div class="progress-control_">
        <a
          class="home_tab home_tab_actived"
          :key="'0'"
          @click.stop="handleItem_(0)"
          >{{ selectArr[0].name }}</a
        >

        <el-input
          :input-style="{ textAlign: 'center' }"
          class="home_tab_input"
          v-model="percentage_"
          placeholder=""
          size="small"
        />

        <a
          class="home_tab home_tab_actived"
          :key="'1'"
          @click.stop="handleItem_(1)"
          >{{ selectArr[1].name }}</a
        >
      </div>

      <div class="demo-progress_">
        <el-progress
          type="dashboard"
          stroke-width="12"
          :percentage="percentage_"
          :color="colors"
          width="180"
        >
          <template #default="{ percentage }">
            <p class="percentage-value">{{ percentage }}<span>μg/m³</span></p>
            <p class="percentage-label" style="line-height: 52px">
              TSP污染预测
            </p>
          </template>
        </el-progress>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import { unwarp } from "@/utils/tools.js";

export default {
  components: {},
  props: ["matrix", "x", "y"],
  data() {
    return {
      styleType: "",
      customerId: this.$store.state.customerId,
      selectIndex: 0,
      selectArr: [{ name: "-" }, { name: "+" }],
      colors: [
        { color: "#e6a23c", percentage: 40 },
        { color: "#5cb87a", percentage: 60 },
        { color: "#1989fa", percentage: 80 },
        { color: "#6f7ad3", percentage: 100 },
        { color: "#f56c6c", percentage: 150 },
      ],
      percentage: 0,
      percentage_: 0,
      changeTimer: null,
    };
  },
  computed: {
    curStyleTypeVal() {
      return this.$store.state.styleType;
    },
  },
  watch: {
    percentage_: {
      handler(newVal, oldVal) {
        if (
          newVal.toString().indexOf(".") > -1 &&
          newVal.toString().split(".")[1].length > 2
        ) {
          this.percentage_ = oldVal;
          this.$message.warning("最多支持两位小数");
          return;
        }
        if(isNaN(newVal)) {
          this.$message.warning("请输入数字");
          this.percentage = oldVal;
          return;
        }
        if (this.changeTimer) {
          clearTimeout(this.changeTimer);
        }
        this.setData();
        this.changeTimer = setTimeout(() => {
          this.$store.commit("setThreshold_", newVal);
        }, 5000);
      },
      deep: true,
    },
    percentage: {
      handler(newVal, oldVal) {
        if (
          newVal.toString().indexOf(".") > -1 &&
          newVal.toString().split(".")[1].length > 2
        ) {
          this.$message.warning("最多支持两位小数");
          this.percentage = oldVal;
          return;
        }
        if(isNaN(newVal)) {
          this.$message.warning("请输入数字");
          this.percentage = oldVal;
          return;
        }
        if (this.changeTimer) {
          clearTimeout(this.changeTimer);
        }
        this.setData();
        this.changeTimer = setTimeout(() => {
          this.$store.commit("setThreshold", newVal);
        }, 5000);
      },
      deep: true,
    },
    curStyleTypeVal: {
      handler(newVal, oldVal) {
        this.styleType = newVal;
        this.typeChange();
      },
      deep: true,
    },
  },
  created() {
    this.styleType = this.$store.state.styleType;
    // this.percentage = bmeConfig.threshold ? bmeConfig.threshold : 80;
    // this.percentage_ = bmeConfig.threshold ? bmeConfig.threshold : 80;
  },
  mounted() {
    this.getData();

    let w = $(this.$refs.trend).outerWidth();
    let h = $(this.$refs.trend).outerHeight();

    this.$emit("componentInit", {
      w: w,
      h: h,
      matrixType: this.matrix,
      x: this.x,
      y: this.y,
    });
    this.typeChange();
  },
  unmounted() {},
  methods: {
    async getData() {
      let getCustomValueConfig =
        CONFIG.requestName + this.$apiOpt.getCustomValueConfig;
      let res = await this.$apiUtils.get(getCustomValueConfig, {
        customerId: this.customerId,
      });
      if (res) {
        let data = JSON.parse(JSON.stringify(res));
        this.percentage = Number(data.val1);
        this.percentage_ = Number(data.val2);
      }
    },
    async setData() {
      let saveCustomValueConfig =
        CONFIG.requestName + this.$apiOpt.saveCustomValueConfig;
      let res = await this.$apiUtils.get(saveCustomValueConfig, {
        customerId: this.customerId,
        val1: this.percentage,
        val2: this.percentage_,
      });
      if (res) {
        this.getData();
      }
    },
    handleItem(val) {
      if (val > 0) {
        this.percentage++;
      } else {
        if (this.percentage > 0) {
          this.percentage--;
        }
      }
    },
    handleItem_(val) {
      if (val > 0) {
        this.percentage_++;
      } else {
        if (this.percentage_ > 0) {
          this.percentage_--;
        }
      }
    },
    typeChange() {
      if (this.styleType == "typeGreen") {
        this.$nextTick(() => {
          $(".trend .tab").css({ "padding-top": "20px", height: "25px" });
        });
      } else if (this.styleType == "typeDark") {
        this.$nextTick(() => {
          $(".trend .tab").css({ "padding-top": "initial", height: "initial" });
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped="scoped">
.progress-control {
  position: absolute;
  left: 70px;
  bottom: -10px;
  z-index: 99;
}

.demo-progress {
  position: absolute;
  left: 80px;
  bottom: 25px;
}

.progress-control_ {
  position: absolute;
  right: 70px;
  bottom: -10px;
  z-index: 99;
}

.demo-progress_ {
  position: absolute;
  right: 80px;
  bottom: 25px;
}

.home_tab_actived {
  margin-top: 30px;
  display: inline-block;
}

.home_tab_input {
  margin: 10px 5px 10px 15px;
  font-size: 28px;
  width: 80px;
  height: 60px;
  line-height: 60px;
  text-align: center;
}

.percentage-value {
  display: block;
  color: #fff;
  font-size: 40px;
  font-family: "number";
  span {
    margin-left: 5px;
    font-size: 15px;
    font-family: "initial";
  }
}
.percentage-label {
  width: 80%;
  font-size: 18px;
  line-height: 26px;
  margin-left: 10%;
  height: 60px;
  display: block;
  color: #fff;
  padding: 10px 0;
}
.trend {
  width: 600px;
  height: 250px;
  .tab {
    justify-content: flex-end;
    z-index: 1;
    display: flex;
  }
  .typeBlue {
    .home_tab {
      width: 56px;
      height: 26px;
      background: url("./img/tab_default.png") no-repeat;
      background-size: 100% 100%;
      line-height: 26px;
    }
    .home_tab_actived {
      width: 56px;
      height: 26px;
      background: url("./img/tab_active.png") no-repeat;
      background-size: 100% 100%;
      line-height: 26px;
    }
  }
}
</style>
